// src/components/EventCards.js
import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Skeleton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/DeleteForever"; // Потеря заказа
import MoneyOffIcon from "@mui/icons-material/MoneyOff"; // Потеря денег
import CompareArrowsIcon from "@mui/icons-material/CompareArrows"; // Манипуляции
import BuildIcon from "@mui/icons-material/Build"; // Нестандартные действия
import FadeIn from "./motion/FadeIn";
import { PRESS_SX, dimSx } from "../styles/tokens";

// 🔹 Цвета и иконки по категориям
const GROUPS = [
  {
    key: "loss_orders",
    title: "Потеря заказа",
    description: "Удаление заказа, отмена пречека, сторнирование чека",
    gradient: "linear-gradient(135deg, #ffcc80 0%, #ff8a65 100%)",
    icon: <DeleteIcon sx={{ fontSize: 36, color: "#000" }} />,
  },
  {
    key: "loss_money",
    title: "Потеря денег",
    description: "Оплата без выручки, возврат предоплаты",
    gradient: "linear-gradient(135deg, #ffab91 0%, #ef5350 100%)",
    icon: <MoneyOffIcon sx={{ fontSize: 36, color: "#000" }} />,
  },
  {
    key: "manipulations",
    title: "Манипуляции с позициями",
    description: "Перенос позиций, удаление отпечатанных или неотпечатанных блюд",
    gradient: "linear-gradient(135deg, #fff59d 0%, #fbc02d 100%)",
    icon: <CompareArrowsIcon sx={{ fontSize: 36, color: "#000" }} />,
  },
  {
    key: "unusual_actions",
    title: "Нестандартные действия",
    description: "Свободная цена, повторная печать на кухню",
    gradient: "linear-gradient(135deg, #ce93d8 0%, #9575cd 100%)",
    icon: <BuildIcon sx={{ fontSize: 36, color: "#000" }} />,
  },
];

const EventCards = ({ eventCounts = {}, loading, dimmed = false, handleEventDetailsClick }) => {
  // Загрузка — скелетоны по форме карточек групп (без спиннера)
  if (loading) {
    return (
      <Grid container spacing={2} aria-busy="true">
        {GROUPS.map((group) => (
          <Grid item xs={12} md={6} key={group.key}>
            <Skeleton variant="rounded" height={96} sx={{ borderRadius: 3 }} />
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    // Приглушение — на обёртке: Fade сам задаёт opacity своему элементу
    <Box sx={dimSx(dimmed)}>
    <FadeIn>
    <Grid container spacing={2}>
      {GROUPS.map((group) => {
        // eventCounts === null — загрузка завершилась ошибкой, количество неизвестно
        const count = eventCounts ? eventCounts[group.key] || 0 : null;
        const clickable = count > 0;

        return (
        <Grid item xs={12} md={6} key={group.key}>
          <Card
            onClick={clickable ? () => handleEventDetailsClick(group.key) : undefined}
            sx={{
              cursor: clickable ? "pointer" : "default",
              borderRadius: 3,
              background: group.gradient,
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              ...(clickable && {
                ...PRESS_SX,
                "&:hover": {
                  transform: "scale(1.02)",
                  boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
                },
              }),
            }}
          >
            <CardContent
              sx={{
                color: "#000",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "row",
                p: 2,
              }}
            >
              {/* Левая часть: текст */}
              <Box>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  {group.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    opacity: 0.9,
                    maxWidth: "240px",
                    color: "#212121",
                  }}
                >
                  {group.description}
                </Typography>
              </Box>

              {/* Правая часть: иконка + число */}
              <Box sx={{ textAlign: "center", minWidth: 60 }}>
                {group.icon}
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: "900",
                    mt: 0.5,
                    color: "#000",
                    textShadow: "0 1px 2px rgba(255,255,255,0.3)",
                  }}
                >
                  {count ?? "—"}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        );
      })}
    </Grid>
    </FadeIn>
    </Box>
  );
};

export default EventCards;
